import { useEffect, useRef } from 'react';
import { useStore } from 'zustand';

import { PackType, packagesStore } from '../PackageStore';

import { useFilteredPackages } from './useFilterPackages';

export const useInitialPackType = () => {
  const { filteredNightStayPacks, filteredDaytimePacks } =
    useFilteredPackages();
  const setPackType = useStore(packagesStore, (state) => state.setPackType);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      return;
    }

    const hasNightStayPacks = filteredNightStayPacks.length > 0;
    const hasDaytimePacks = filteredDaytimePacks.length > 0;

    if (!hasNightStayPacks && !hasDaytimePacks) {
      return;
    }

    hasInitialized.current = true;

    if (!hasNightStayPacks && hasDaytimePacks) {
      setPackType(PackType.DAYTIME);
    } else if (hasNightStayPacks) {
      setPackType(PackType.NIGHT_STAY);
    }
  }, [filteredNightStayPacks, filteredDaytimePacks, setPackType]);
};
